import { SamplePack } from '@arpeggi/shared'
import { FC } from 'react'
import { useMintCollectionButton } from '../hooks'
import { CollectButton } from '../primitives'

interface Props {
  sp: SamplePack
  isPresale?: boolean
}

export const MintCollectionButton: FC<Props> = ({ sp, isPresale }) => {
  const { isHolder, mintIsLive, mintSoldOut, allowedToMint, mint, isMinting, buttonText } =
    useMintCollectionButton(sp, isPresale)

  return (
    <CollectButton
      disabled={isHolder || !mintIsLive || mintSoldOut || !allowedToMint}
      onClick={() => mint(isPresale)}
      loading={isMinting}
    >
      {buttonText}
    </CollectButton>
  )
}
